import { styled as r } from "@lokalise/styled";
import { value as e, spacing as o } from "../../../utils/theme/index.js";
const i = r.hr`
	display: block;
	height: 1px;
	background-color: ${e("color.border.input.default")};
	margin: ${o(1, 0)} !important; // Necessary to override #tasks.tab-pane hr
	border: none;
`;
i.displayName = "MenuDivider";
export {
  i as MenuDivider
};
//# sourceMappingURL=index.js.map
